module.exports = __webpack_public_path__ + "static/884230bb-1792-41a4-aff0-4d2e28547d64-700.0e2b7c8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/st-margarets-west-hoathy/884230bb-1792-41a4-aff0-4d2e28547d64-700.jpg
// module id = 1127
// module chunks = 168707334958949